module.exports = __webpack_public_path__ + "static/media/vegan-cover.7649d1de.jpg";